export const NOTIFY_SUCCESS = 'NOTIFY_SUCCESS';
export const NOTIFY_ERROR = 'NOTIFY_ERROR';




// WEBPACK FOOTER //
// ./src/constants/notification-action-type.js